<script>
    export default {
        name: 'app-heading',
        
        render(createElement) {
            return createElement(this.element, this.$slots.default);
        },
        props: {
            element: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    h1, h2, h3, h4, h5, h6 {
        @apply .font-normal;
    }
</style>



// WEBPACK FOOTER //
// src/components/Heading.vue